module.exports = __webpack_public_path__ + "static/media/logo-픽셀릭코리아@2x.074a9031.png";